/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneIcon16Regular = forwardRef('SendPaperplaneIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.674 2.934C1.437 1.714 2.702.751 3.815 1.305l10.748 5.352c1.108.552 1.108 2.134 0 2.686L3.815 14.695c-1.113.554-2.378-.408-2.141-1.629L2.658 8l-.984-5.066ZM4.04 8.75l-.895 4.602L13.894 8 3.146 2.648l.895 4.602h3.722a.75.75 0 1 1 0 1.5H4.041Z" })));
});
